export const PAYPAL_RETURN_NO_APPROVAL_MESSAGE =
  "We couldn't find this PayPal checkout in your browser. If you completed the payment, your confirmation and serial numbers are on their way by email; otherwise return to your cart and check out again.";

export type PaypalApprovalRecord = {
  orderId?: string;
  cartId?: string;
  user?: unknown;
} | null;

export type PaypalReturnCaptureRequest = {
  id: string;
  type: 'order';
  cartId?: string;
  isFinal: true;
  user: unknown;
};

/**
 * Decide how the PayPal return page should call capture.
 *
 * Normal case: the approval record saved before the redirect is still in
 * localStorage. Fallback: it is gone (reload after success, return in a
 * different browser session) but the shopper is signed in, so capture can run
 * on their identity — the server replays the confirmation if this order
 * already completed the cart, or rejects safely without charging.
 */
export function buildPaypalReturnCaptureRequest({
  orderId,
  cartId,
  approval,
  currentUserId,
}: {
  orderId: string;
  cartId: string | null;
  approval: PaypalApprovalRecord;
  currentUserId?: string;
}): { request: PaypalReturnCaptureRequest } | { error: string } {
  if (approval && approval.orderId === orderId) {
    return {
      request: {
        id: orderId,
        type: 'order',
        cartId: approval.cartId ?? cartId ?? undefined,
        isFinal: true,
        user: approval.user,
      },
    };
  }

  if (cartId && currentUserId) {
    return {
      request: {
        id: orderId,
        type: 'order',
        cartId,
        isFinal: true,
        user: { id: currentUserId },
      },
    };
  }

  return { error: PAYPAL_RETURN_NO_APPROVAL_MESSAGE };
}
